module.exports = __webpack_public_path__ + "media/agent_2_scale.a9fb95eb.mp3";